// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoSlider_wrapper__Mk1X5","track":"LogoSlider_track__CiYN7","marquee":"LogoSlider_marquee__JWeUD","item":"LogoSlider_item__UXi-R","logo":"LogoSlider_logo__dK2bx"};